import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import { FUNDRAISING_LEAD_IN, FUNDRAISING_PANELS } from './linkCopy';

/**
 * The three fixed disclosure panels of wireframe p.6, which no organization
 * may change, with the sentence that says so (P27, C4). Fundraising's only
 * (P10).
 */
export function FundraisingDisclosures() {
  return (
    <Box component="section">
      <Typography color="text.secondary" data-testid="arc-fundraising-lead-in-message">
        {FUNDRAISING_LEAD_IN}
      </Typography>
      <Box
        sx={{
          display: 'grid',
          gap: 2,
          mt: 2,
          gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: 'repeat(3, minmax(0, 1fr))' },
        }}
      >
        {FUNDRAISING_PANELS.map((panel, index) => (
          <Paper
            key={panel.title}
            variant="outlined"
            sx={{ p: 2 }}
            data-testid={`arc-fundraising-disclosure-card-${String(index + 1)}`}
          >
            <Typography variant="subtitle1" component="h3" sx={{ fontWeight: 600 }}>
              {panel.title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {panel.text}
            </Typography>
          </Paper>
        ))}
      </Box>
    </Box>
  );
}
